/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  fetchViewRlhRewardsRequest,
  RootState,
  useAppDispatch,
} from '@rb-serve-app/core';
import Spinner from '../../../components/Spinner';
import { useSelector } from 'react-redux';
import Breadcrumbs from '../../../components/BreadCrumbs';
import Button from '../../../components/Button';
import { RightArrow } from '../../../assets/svg/ArrowIcon';
import { useState, useEffect, useMemo } from 'react';
import moment from 'moment';
import { logBrazeCustomEvent } from '../../../config/braze';

const RoamLikeHomeEligible = () => {
  const dispatch = useAppDispatch();
  // Get data from Redux store
  const { customerId, accountId, accountDetails } = useSelector(
    (state: RootState) => state.user
  );

  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );

  const { entries, assets } = contentfulData;
  const rb_RoamLikeHome = entries?.rb_roam_like_home;
  const { rb_roam_like_home, rb_links } = entries;
  const { rb_rlh_icon } = assets;
  const content = rb_roam_like_home?.rbRoamLikeHomeEligible;

  const {
    bankAccountDetail,
    viewRlhRewardsLoading,
    viewRlhRewardsError,
    viewRlhRewards,
  } = useSelector((state: RootState) => state.profile);

  type LastRewardType = {
    activity: string;
    expirationDate: string;
    balanceUnit: string;
    // add other required fields
  };
  const [notEligibleBanner, setNotEligibleBanner] = useState(false);
  const [almostThere, setAlmostThere] = useState(false);
  const [listAvailable, setListAvailable] = useState(false);
  const [viewRLHError, setViewRLHError] = useState(false);
  type RewardEntry = {
    id: string;
    date: string;
    phone: string;
    activity: string;
    startDate: string;
    expirationDate: string;
  };
  type Activity = {
    activitySeqnumber: string;
    subscriberNo: string;
    activity: string;
    startDate: string;
    expirationDate: string;
    balanceUnit: string;
    redeemedUnits: string;
    remainingUnits: string;
    updateReason: string;
    updateDate: string;
    billCycle: string;
    billSeqnumber: string;
    billRedeemedUnit: string;
    billStatus: string;
    eligibilityInd: string;
    statusDate: string;
  };

  type Section = Activity[];

  const [sectionsData, setSectionsData] = useState<Section[]>([]);
  const [lastReward, setLastReward] = useState<LastRewardType | any>(null);

  useEffect(() => {
    logBrazeCustomEvent('viewed_roam_like_home');
  }, []);

  useEffect(() => {
    if (bankAccountDetail?.bankAccountResponse?.ban) {
      dispatch(
        fetchViewRlhRewardsRequest({
          ban: bankAccountDetail?.bankAccountResponse?.ban,
          accountId: accountId,
        })
      );
    }
  }, [bankAccountDetail?.bankAccountResponse?.ban]);

  const yearLabels = useMemo(() => {
    return sectionsData.map((section: any) => {
      const startMonthYear = moment(section.startDate).format('MMMM YYYY');
      const endMonthYear = moment(section.expirationDate).format('MMMM YYYY');
      return `${content?.Activity} ${content?.ValidFrom} ${startMonthYear} ${content?.to} ${endMonthYear}`;
    });
  }, [sectionsData, content]);

  const convertRewardsToSections = (rewardsData: any) => {
    if (!Array.isArray(rewardsData?.rewardsactivity?.rewardDetails)) return [];

    const sections = rewardsData.rewardsactivity.rewardDetails
      .map((section: any) => {
        const activities: Activity[] = section?.rewardAcitivityDetails || [];
        const filteredActivities = activities.filter(
          (activity: Activity) => activity?.updateReason === 'BILL'
        );

        const matchingBalance =
          rewardsData?.rewardsbalance?.rewardDetails?.find(
            (item: any) => item.sequenceNumber === section.sequenceNumber
          );

        return {
          startDate: matchingBalance?.startDate || '',
          expirationDate: matchingBalance?.expirationDate || '',
          data: filteredActivities,
        };
      })
      .filter((s: any) => Array.isArray(s.data) && s.data.length > 0)
      .sort((a: any, b: any) => {
        const dateA = new Date(a.startDate || 0).getTime();
        const dateB = new Date(b.startDate || 0).getTime();
        return dateB - dateA;
      });

    return sections;
  };

  const getLastRewardValues = (rewardsData: any) => {
    const rewardDetails = rewardsData?.rewardDetails;
    if (!rewardDetails || rewardDetails.length === 0) {
      console.warn('No reward details found');
      return null;
    }
    const lastItem = rewardDetails[rewardDetails.length - 1];
    return {
      remainingUnits: lastItem.remainingUnits,
      balanceUnit: lastItem.balanceUnit,
      startDate: lastItem.startDate,
      expirationDate: lastItem.expirationDate,
      statusDate: lastItem.statusDate,
    };
  };
  const [heightStyle, setHeightStyle] = useState({ height: 'auto' });

  useEffect(() => {
    if (viewRlhRewards) {
      if (viewRlhRewards.RLH_SCREEN_IND === 'WLS') {
        const result = getLastRewardValues(viewRlhRewards?.rewardsbalance);
        setLastReward(result);
        const sections = convertRewardsToSections(viewRlhRewards);
        setSectionsData(sections);
        setListAvailable(true);
      } else if (
        viewRlhRewards.RLH_SCREEN_IND === 'RLH ALMOST THERE' ||
        viewRlhRewards.RLH_SCREEN_IND === 'RLH_ALMOST_THERE'
      ) {
        setAlmostThere(true);
      } else if (
        viewRlhRewards.RLH_SCREEN_IND === 'WLS_SUSPENDED' ||
        viewRlhRewards.RLH_SCREEN_IND === 'WLS_IN_ELIGIBLE' ||
        viewRlhRewards.RLH_SCREEN_IND === 'WLS_IN_ELIGIBLE'
      ) {
        setNotEligibleBanner(true);
        setAlmostThere(true);
      }
    }
  }, [viewRlhRewards]);

  const breadcrumbs = [
    {
      name: `${rb_RoamLikeHome?.webRlhKeys?.breadcrumb_titles?.rewards}`,
      href: '/rewards',
    },
    {
      name: `${rb_RoamLikeHome?.webRlhKeys?.breadcrumb_titles?.roam_like_home}`,
      href: '/roam-like-home',
    },
  ];

  const setupLocale = () => {
    try {
      const deviceLocale = localStorage.getItem('language');
      const localeToUse = deviceLocale === 'fr' ? 'fr' : 'en';

      moment.locale(localeToUse);

      return localeToUse;
    } catch (error) {
      console.warn('Error setting moment locale:', error);
      moment.locale('en');
      return 'en';
    }
  };
  const locale = setupLocale();

  useEffect(() => {
    const updateHeight = () => {
      const width = window.innerWidth;
      if (width < 768) {
        // Mobile
        setHeightStyle({ height: '200px' });
      } else if (width >= 768 && width < 1280) {
        // Tablet and Laptop
        setHeightStyle({ height: '-webkit-fill-available' });
      } else {
        // Desktop
        setHeightStyle({ height: 'auto' });
      }
    };

    updateHeight(); // run on mount
    window.addEventListener('resize', updateHeight);
    return () => window.removeEventListener('resize', updateHeight);
  }, []);

  return (
    <div>
      {rb_RoamLikeHome && !viewRlhRewardsLoading && lastReward ? (
        <div className="bg-bg-body py-4 px-4 md:px-8 h-full flex flex-col">
          <Breadcrumbs items={breadcrumbs} />

          <main className="bg-white p-0 md:p-[30px] lg:rounded-lg shadow-none flex-1 flex-col overflow-y-scroll scrollbar-hide">
            <h2
              aria-label={
                rb_RoamLikeHome?.webRlhKeys?.breadcrumb_titles?.roam_like_home
              }
              className="text-[18px] text-black font-[600] mb-5"
            >
              {rb_RoamLikeHome?.webRlhKeys?.breadcrumb_titles?.roam_like_home}
            </h2>
            <div className="mb-4">
              <div className="flex flex-col md:flex-row items-start gap-4 pl-0 pr-0 md:pr-4 py-0 border border-light-gray-border rounded-[5px] bg-[#FAFAFA]">
                <img
                  src={assets?.rlh_card_image}
                  alt="Group of people enjoying travel"
                  className="w-full md:w-48 rounded object-cover"
                  style={heightStyle}
                />
                <div className="flex justify-center flex-col ">
                  <h2
                    aria-label={rb_RoamLikeHome?.webRlhKeys?.imgTitle}
                    className="text-[18px] text-black font-[600]"
                  >
                    {rb_RoamLikeHome?.webRlhKeys?.imgTitle}
                  </h2>
                  {/* flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 9px; */}
                  <div className="flex flex-col justify-start items-start xl:justify-center xl:flex-row xl:items-center  gap-[9px] xl:gap-10">
                    <p
                      aria-label={rb_RoamLikeHome?.webRlhKeys?.imgDesc}
                      className="text-[14px] font-[400] text-black mt-2"
                    >
                      {rb_RoamLikeHome?.webRlhKeys?.imgDesc}
                    </p>

                    <Button
                      ariaLabel={rb_RoamLikeHome?.webRlhKeys?.learnMoreCta}
                      className=" max-w-full md:max-w-[200px] w-full h-[48px] px-[16px] py-[12px]"
                      variant="solid"
                      onClick={() =>
                        window.open(
                          rb_links?.rbLinksCollection?.rlh_learn_more,
                          '_blank'
                        )
                      }
                    >
                      {rb_RoamLikeHome?.webRlhKeys?.learnMoreCta}{' '}
                      <RightArrow fill="#fff" />
                    </Button>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-[#F1FDFF] p-[15px] md:py-[12px] md:px-[40px] ">
              <p className="text-[15px] md:text-[22px] text-black font-[300]">
                <span className="text-primary-red  font-[600]">
                  {`${parseInt(lastReward?.remainingUnits)} ${content?.of} ${parseInt(lastReward?.balanceUnit)} ${lastReward?.balanceUnit === 1 ? content?.dayRemaining : content?.daysRemaining}`}
                </span>{' '}
                {`${'('}${content?.asOf} ${moment(lastReward?.statusDate).locale(locale).format('MMM D YYYY')})`}{' '}
              </p>
              <p className="text-black text-[15px] md:text-[22px]">
                <span className="italic font-[300]">
                  {`${content?.ValidFrom} ${moment(lastReward?.startDate).locale(locale).format('MMM YYYY')} ${content?.to} ${moment(lastReward?.expirationDate).locale(locale).format('MMM YYYY')}`}
                </span>
                <span
                  className="font-[600]"
                  aria-label={rb_RoamLikeHome?.webRlhKeys?.offerContent}
                >
                  {' '}
                  {rb_RoamLikeHome?.webRlhKeys?.offerContent}
                </span>
              </p>
            </div>

            {/* ------- table start ----- */}

            {sectionsData.length > 0 &&
              sectionsData.map((section: any, sectionIndex: number) => (
                <div
                  key={sectionIndex}
                  className="overflow-x-auto mt-6"
                  role="region"
                  aria-label={`Roam Like Home activity table ${sectionIndex + 1}`}
                >
                  <h3
                    aria-label={yearLabels[sectionIndex]}
                    className="text-[16px] font-[550] text-primary-red mb-7"
                  >
                    {yearLabels[sectionIndex] || ''}
                  </h3>

                  {section.data.length > 0 ? (
                    <div>
                      <table className="min-w-full text-sm text-left text-gray-700">
                        <caption className="sr-only">
                          Roam Like Home Activity Table {sectionIndex + 1}
                        </caption>
                        <thead className="text-[16px] text-gray-500">
                          <tr>
                            <th
                              aria-label={content?.date}
                              scope="col"
                              className="px-4 py-3 border-b border-light-gray-border"
                            >
                              {content?.date}
                            </th>
                            <th
                              aria-label={content?.phoneNumber}
                              scope="col"
                              className="px-4 py-3 border-b border-light-gray-border"
                            >
                              {content?.phoneNumber}
                            </th>
                            <th
                              aria-label={content?.Activity}
                              scope="col"
                              className="px-4 py-3 border-b border-light-gray-border"
                            >
                              {content?.Activity}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {section.data.map(
                            (activity: any, activityIndex: number) => (
                              <tr key={activityIndex}>
                                <td
                                  aria-label={moment(
                                    activity.billCycleCloseDate ||
                                      activity.startDate
                                  ).format('MMM YYYY')}
                                  className="px-4 py-3 border-b border-light-gray-border whitespace-nowrap"
                                >
                                  {moment(
                                    activity.billCycleCloseDate ||
                                      activity.startDate
                                  ).format('MMM YYYY')}
                                </td>
                                <td
                                  aria-label={activity.subscriberNo}
                                  className="px-4 py-3 border-b border-light-gray-border"
                                >
                                  {activity.subscriberNo}
                                </td>
                                <td className="px-4 py-3 border-b border-light-gray-border">
                                  {parseInt(
                                    activity.billRedeemedUnit ||
                                      activity.redeemedUnits ||
                                      '0',
                                    10
                                  )}{' '}
                                  {parseInt(
                                    activity.billRedeemedUnit ||
                                      activity.redeemedUnits ||
                                      '0',
                                    10
                                  ) === 1
                                    ? content?.dayRedeemed
                                    : content?.daysRedeemed}{' '}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <p
                      aria-label={content?.noDaysRedeemed}
                      className="text-[16px] font-[350] text-black text-center mt-5"
                    >
                      {' '}
                      {content?.noDaysRedeemed}
                    </p>
                  )}
                  <p
                    aria-label={content?.whenYouUseRoamLikeHome}
                    className="text-[16px] font-[350] text-black text-center mt-1 mb-5"
                  >
                    {content?.whenYouUseRoamLikeHome}
                  </p>
                </div>
              ))}

            {/* ------- table end ----- */}
          </main>
        </div>
      ) : (
        <div className="flex justify-center items-center h-[80vh]">
          <Spinner aria-label="Loading statements" />
        </div>
      )}
    </div>
  );
};

export default RoamLikeHomeEligible;
